export default __webpack_public_path__ + "static/media/Group 2166.fdfcf161.png";